import * as Types from "../action.types"
import * as Models from "../../models/index"
import * as Services from "../../service/index"
import * as toastr from "toastr"

export const resetPassword = () => (d: Function, gs: () => Models.StoreState) => {
    d({
        type: Types.PWD_EXPIRED_PENDING
    });

    Services.Recovery.resetExpiredPassword({
        username: gs().login.userName,
        newPassword: gs().pwdSecurity.password,
        oldPassword: gs().pwdSecurity.oldPassword,
        confirmPassword: gs().pwdSecurity.confirmPassword
    }).then((result) => {
        if (!!result.data) {
            toastr.success(result.message)
        }
        else {
            toastr.warning(result.message)
           
        }
        d({
            type: Types.PWD_EXPIRED_RESET_PASSWORD,
            payload: result.data ? result.message : null
        })
        
        if (!!gs().pwdExpired.resultMessage) {
            window.location.href = "/login";
        }
    })
}